import { render, staticRenderFns } from "./SettingsSlider.vue?vue&type=template&id=937cc3bc&scoped=true&"
import script from "./SettingsSlider.vue?vue&type=script&lang=js&"
export * from "./SettingsSlider.vue?vue&type=script&lang=js&"
import style0 from "./SettingsSlider.vue?vue&type=style&index=0&id=937cc3bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937cc3bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('937cc3bc')) {
      api.createRecord('937cc3bc', component.options)
    } else {
      api.reload('937cc3bc', component.options)
    }
    module.hot.accept("./SettingsSlider.vue?vue&type=template&id=937cc3bc&scoped=true&", function () {
      api.rerender('937cc3bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/Settings/SettingsSlider.vue"
export default component.exports